<template>
  <mobile-login v-if="isMobile" />
  <desktop-login v-else />
</template>

<script>
  import { isMobile } from 'mobile-device-detect'
  import MobileLogin from '../../error/MobileApp'
  // import MobileLogin from '../../mobile/login/Login'
  import DesktopLogin from '../../desktop/login/Login'

  export default {
    name: 'common-login',
    components: {
      'mobile-login': MobileLogin,
      'desktop-login': DesktopLogin
    },
    data () {
      return {
        isMobile
      }
    }
  }
</script>
